/**
 * 急速赛马动画容器
 */
import React, { Component, PropTypes } from 'react'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { Link } from 'react-router'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as lotteryAction from '../../actions/lotteryAction'
import * as baseAction from '../../actions/baseAction'
import Horse from './Horse.jsx'
import RankBox from './RankBox.jsx'
import CountDown from './CountDown.jsx'
import TopThree from './TopThree.jsx'
import Loader from '../icon/Loader.jsx'
import { makeBetweenNo } from '../../helpers/unit'

class JssmContainer extends React.Component {

  constructor(props) {
    super(props);
    this.startRun = this.startRun.bind(this);
    this.makeAnimation = this.makeAnimation.bind(this);
    this.cycleAnimation = this.cycleAnimation.bind(this);
    this.countdown = this.countdown.bind(this);
    this.horse = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10']
    this.state = {
      // 5种状态 -1: 还没开始显示 0: 倒计时开跑 1: 正在跑 2: 开奖显示冠亚军 3: 错误
      ranks: null,
      rankCode: [],
      issue: '00000000-000',
      status: -1
    }
    // 动画显示状态对应时间区间
    this.animateArea = {
      countdown: _.concat(makeBetweenNo(0, 60), makeBetweenNo(110, 120)),
      run: makeBetweenNo(65, 109),
      winner: makeBetweenNo(61, 109),
      error: makeBetweenNo(61, 70),
    }
  }

  componentDidMount(){
    this.makeAnimation(this.props);
  }

  componentWillUnmount(){
    if (this.rankTimer) {window.clearInterval(this.rankTimer)}
    if (this.countdownTimer) {window.clearTimeout(this.countdownTimer)}
  }

  componentWillReceiveProps(nextProps) {
    // 还没加载完
    const __window = nextProps.__METHOD.toJS().windows[nextProps.windowId];
    const __oldWindow = this.props.__METHOD.toJS().windows[nextProps.windowId];
    if (!__window.current_issue || !__window.current_issue.current || !__window.current_issue.history) {
      return;
    }
    const { current, history, countdown} = __window.current_issue;
    // 第一次加载
    if (this.state.status == -1) {
      this.cycleAnimation(nextProps, countdown);
      return;
    }
    // 如果倒计时变了，矫正倒计时
    if (countdown != __oldWindow.current_issue.countdown) {
      this.cycleAnimation(nextProps, countdown);
      return;
    }

  }

  // 初始化动画
  cycleAnimation(props, countdown){
    const { setIssue } = this.props;
    // 倒计时没变，推送了新奖期
    if (!countdown && countdown != 0) {
      countdown = this.state.countdown;
    }
    const __window = props.__METHOD.toJS().windows[this.props.windowId];
    const { current, history} = __window.current_issue;
    // 开始倒计时
    this.countdown(countdown);
    const _realCountDown = countdown;
    this.setState({
      countdown: (_realCountDown >= 110 && _realCountDown <= 120) ? _realCountDown - 110 : _realCountDown + 10
    })
    // 倒计时
    if (_.includes(this.animateArea.countdown, _realCountDown)) {
      if (this.rankTimer) {window.clearInterval(this.rankTimer); this.rankTimer=null;}
      this.setState({
        status: 0,
        issue: history.issue,
        ranks: history.split_code,
      })
      setIssue(history.issue);
      return;
    }
    // 跑马
    if (_.includes(this.animateArea.run, _realCountDown) && current.issue.split('-')[1] - history.issue.split('-')[1] > 1) {
      this.setState({
        status: 1,
        issue: current.issue.split('-')[0] + '-' + (Number(current.issue.split('-')[1]) - 1),
        rankCode: []
      })
      this.delaySecond = 1;
      setIssue(current.issue.split('-')[0] + '-' + (Number(current.issue.split('-')[1]) - 1));
      this.startRun();
      return;
    }
    // 显示前三名
    if (_.includes(this.animateArea.winner, _realCountDown) && current.issue.split('-')[1] - history.issue.split('-')[1] == 1) {
      this.delaySecond ++;
      if (this.delaySecond <= 4) {
        this.setState({
          rankCode: history.split_code
        })
        return;
      }
      if (this.rankTimer) {window.clearInterval(this.rankTimer); this.rankTimer=null;}
      this.setState({
        status: 2,
        ranks: history.split_code,
        issue: history.issue
      })
      setIssue(history.issue);
      return;
    }
    // 错误
    if (_.includes(this.animateArea.error, _realCountDown) && current.issue.split('-')[1] - history.issue.split('-')[1] > 1) {
      if (this.rankTimer) {window.clearInterval(this.rankTimer); this.rankTimer=null;}
      this.setState({
        status: 3,
        ranks: history.split_code,
        issue: history.issue
      })
      setIssue(history.issue);
    }
  }

  // 倒计时
  countdown(countdown,){
    if (this.countdownTimer) {window.clearTimeout(this.countdownTimer)}
    this.countdownTimer = window.setTimeout(function(){
      this.cycleAnimation(this.props, countdown == 0 ? 120 : countdown -1)
    }.bind(this), 1000)
  }


  // 开始跑马
  startRun(){
    if (this.rankTimer) {return;}
    // 开启计时器定时查看名次
    this.rankTimer = window.setInterval(function(){
      const horse = document.querySelectorAll('.horse-am');
      const ranks = _.chain(horse).sortBy('offsetLeft').reverse().map((item) => _.last(_.split(item.className, 'no'))).value();
      this.setState({
        ranks: ranks
      })
    }.bind(this), 200)
  }

  // 生成显示动画区
  makeAnimation(){
    const __window = this.props.__METHOD.toJS().windows[this.props.windowId]
    // 未开始显示
    if (this.state.status == -1) {
      return <ReactCSSTransitionGroup 
                transitionAppear={true}
                transitionEnterTimeout={500} 
                transitionLeaveTimeout={500} 
                transitionAppearTimeout ={500} 
                transitionName='opacity'>
               <div className='grass-bg'>
                 <div className='ready' />
                 <Loader />
               </div>
             </ReactCSSTransitionGroup>
    }
    // 倒计时
    if (this.state.status == 0) {
      return <ReactCSSTransitionGroup 
                transitionAppear={true}
                transitionEnterTimeout={500} 
                transitionLeaveTimeout={500} 
                transitionAppearTimeout ={500} 
                transitionName='opacity'>
               <div className='grass-bg'>
                 <div className='ready' />
                 <CountDown time={this.state.countdown} className='countdown' />
               </div>
             </ReactCSSTransitionGroup>
    }
    // 正在跑
    if (this.state.status == 1) {
      return <ReactCSSTransitionGroup 
                transitionAppear={true} 
                transitionEnterTimeout={500} 
                transitionLeaveTimeout={500} 
                transitionAppearTimeout ={500} 
                transitionName='opacity'>
                <div className='grass-bg run'>
                  {_.map(this.horse, (item, index) => <Horse rank={_.indexOf(this.state.rankCode, item)} no={item} key={index} />)}
                </div>
                {
                  this.state.rankCode.length == 10 ? <div className='end-line' /> : null
                }
              </ReactCSSTransitionGroup>
    }
    // 开奖
    if (this.state.status == 2) {
      return <TopThree rank={this.state.ranks} />
    }
    // 错误状态
    if (this.state.status == 3) {
      return <ReactCSSTransitionGroup 
                transitionAppear={true}
                transitionEnterTimeout={500} 
                transitionLeaveTimeout={500} 
                transitionAppearTimeout ={500} 
                transitionName='opacity'>
               <div className='grass-bg'>
                 <div className='ready' />
                 <div className='error'>动画显示出现异常，请刷新页面</div>
               </div>
             </ReactCSSTransitionGroup>
    }
  }


  render() {
    const __window = this.props.__METHOD.toJS().windows[this.props.windowId]
    const display = this.props.__BASE.toJS().config.showBetAnimation;
    const {sizeMode} = this.props;
    return (
      <div className={display ? 'jssm-animation ' + sizeMode.className : 'jssm-animation hidden'}>
        <RankBox issue={this.state.issue} rank={this.state.ranks} flag='jssm'/>
        {
          this.makeAnimation()
        }
      </div>
    ); 

  }
}

reactMixin(JssmContainer.prototype, ImmutableMixin);

function mapStateToProps(state) {
  return {
    __BASE: state.base,
    __USER: state.user,
    __METHOD: state.method
  }
}

function mapDispatchToProps(dispatch) {
  return {
    $$LOTTERY: bindActionCreators(lotteryAction, dispatch),
    $$BASE: bindActionCreators(baseAction, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(JssmContainer)